import React, { useState } from 'react';
import "../Css/Navbar.css";
import logo from "../Images/logo3.jpeg";
import { Link } from 'react-scroll';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className='navbar'>
      <img src={logo} alt='Victor Murithi Logo' className='logo'/>
      
      {/* Desktop Navigation */}
      <div className='desktopMenu'>
        <Link activeClass='active' to='intro' spy={true} smooth={true} offset={-100} duration={500} className='desktopLink'>Home</Link>
        <Link activeClass='active' to='skills' spy={true} smooth={true} offset={-10} duration={500} className='desktopLink'>About</Link>
        <Link activeClass='active' to='portfolio' spy={true} smooth={true} offset={-100} duration={500} className='desktopLink'>Portfolio</Link>
        <Link activeClass='active' to='experience' spy={true} smooth={true} offset={-70} duration={500} className='desktopLink'>Experience</Link>
      </div>

      {/* Mobile Navigation Toggle */}
      <button 
        className='mobileMenuBtn'
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle navigation menu"
      >
        {menuOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* Mobile Menu */}
      <div className={`mobileMenu ${menuOpen ? 'open' : ''}`}>
        <Link 
          activeClass='active' 
          to='intro' 
          spy={true} 
          smooth={true} 
          offset={-100} 
          duration={500} 
          className='mobileLink'
          onClick={() => setMenuOpen(false)}
        >
          Home
        </Link>
        <Link 
          activeClass='active' 
          to='skills' 
          spy={true} 
          smooth={true} 
          offset={-10} 
          duration={500}
          className='mobileLink'
          onClick={() => setMenuOpen(false)}
        >
          About
        </Link>
        <Link 
          activeClass='active' 
          to='portfolio' 
          spy={true} 
          smooth={true} 
          offset={-100} 
          duration={500}
          className='mobileLink'
          onClick={() => setMenuOpen(false)}
        >
          Portfolio
        </Link>
        <Link 
          activeClass='active' 
          to='experience' 
          spy={true} 
          smooth={true} 
          offset={-70} 
          duration={500}
          className='mobileLink'
          onClick={() => setMenuOpen(false)}
        >
          Experience
        </Link>
        <button 
          className='mobileBtn' 
          onClick={() => {
            document.getElementById('experience').scrollIntoView({behavior: 'smooth'});
            setMenuOpen(false);
          }}
        >
          Contact Me
        </button>
      </div>

      {/* Desktop Contact Button */}
      <button 
        className='desktopBtn' 
        onClick={() => {
          document.getElementById('experience').scrollIntoView({behavior: 'smooth'});
        }}
        aria-label="Contact me"
      >
        Contact Me
      </button>
    </nav>
  )
};

export default Navbar;